import React, { useState, useEffect } from "react";
import NumberFormat from 'react-number-format';
import {
    Row, Col,
    Label, Form, FormGroup, Button,
    Modal, ModalHeader, ModalBody, ModalFooter, Input
} from "reactstrap";
import ApiCaller from "../../../../api/apiCaller";

const SampleCalculationLine = {
    lineIndex: 0,
    from_revenue_amount: 0,
    to_revenue_amount: 0,
    percentage_of_revenue: 0,
    fixed_rental_amount: 0,
};

interface SiteRevenueShareRentalCalculationModalProps {
    siteId:number;
    isView?: boolean;
    isShow?: boolean;
    onSaveCallback?: Function;
    onCancelCallback?: Function;
}

export default function SiteRevenueShareRentalCalculationModal({
    siteId,
    isView,
    isShow,
    onSaveCallback,
    onCancelCallback,
}: SiteRevenueShareRentalCalculationModalProps) {
    const [calculationLines, setCalculationLines] = useState<Array<any>>([]);
    const [showModal, setIsShow] = useState<boolean>(isShow || false);
    const toogleModal = () => {
        setIsShow(!showModal);
    }

    const updateAttr = (value:string, attrName:string, lineIndex:number) => {
        let valueData = value;
        if (value.includes(',')) {
            valueData = value.replace(/,/g, '');
        }
        const newCalculationLines = [...calculationLines];
        newCalculationLines[lineIndex] = {
            ...newCalculationLines[lineIndex],
        };
        let valueAfterProcess:any = valueData;
        if (valueData == '') {
            valueAfterProcess = null;
        } else {
            valueAfterProcess = parseFloat(valueData);
        }
        newCalculationLines[lineIndex][attrName] = valueAfterProcess;
        setCalculationLines(newCalculationLines);
    }

    const addNewCalculationLine = () => {
        generateLinesArray();
    }

    const generateLinesArray = () => {
        const newLine = {...SampleCalculationLine};
        newLine.lineIndex = calculationLines.length;
        
        const newCalculationLines = [...calculationLines];
        newCalculationLines.push(newLine);
        setCalculationLines(newCalculationLines);
    }
    
    const removeLine = (lineIndex:number) => {
        let newCalculationLines = [...calculationLines];
        newCalculationLines = newCalculationLines.filter(line => line.lineIndex !== lineIndex);
        newCalculationLines.forEach((line:any, index:number) => {
            line.lineIndex = index;
        });
        setCalculationLines(newCalculationLines);
    }

    const getCalculationResult = async () => {
        const uri = `site_revenue_share_rental_calculation/calculation/${siteId}`;
        const res = await ApiCaller.get(uri);
        if (res?.result) {
            // setDataManipulationMode('update');
            setCalculationLines(res?.result);
        } else {
            // setDataManipulationMode('create');
        }
    }

    const saveCalculationResult = async () => {
        const dataToSubmit = {
            calculations: calculationLines,
        };
        const uri = `site_revenue_share_rental_calculation/calculation/${siteId}`;
        const res = await ApiCaller.post(uri, dataToSubmit);
        if (res?.status == 'ok') {
            setIsShow(false);
            if (onSaveCallback) {
                onSaveCallback();
            }
        } else {
            alert(res.message);
        }
    }

    const cancelModal = () => {
        toogleModal();
        if (onCancelCallback) {
            onCancelCallback();
        }
    }

    useEffect(() => {
        generateLinesArray();
        getCalculationResult();
    }, []);

    return (
        <Modal size="lg" isOpen={showModal} toggle={toogleModal}>
            <ModalHeader toggle={toogleModal}>Tính tiền thuê mặt bằng (chia sẻ doanh thu)</ModalHeader>
            <ModalBody>
                {calculationLines &&
                    <div style={styles.yearListing}>
                        {calculationLines.map((calculationLine:any) => (
                            <Row key={`${calculationLine.lineIndex}`}>
                                <Col xs={12} sm={3}>
                                    <Label>Từ doanh thu</Label>
                                    <FormGroup>
                                        <NumberFormat
                                            className="form-control"
                                            disabled={isView}
                                            thousandSeparator={true}
                                            value={calculationLine.from_revenue_amount}
                                            onChange={(e) => updateAttr(e.target.value, 'from_revenue_amount', calculationLine.lineIndex)}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col xs={12} sm={3}>
                                    <Label>Đến doanh thu</Label>
                                    <FormGroup>
                                        <NumberFormat
                                            className="form-control"
                                            disabled={isView}
                                            thousandSeparator={true}
                                            value={calculationLine.to_revenue_amount}
                                            onChange={(e) => updateAttr(e.target.value, 'to_revenue_amount', calculationLine.lineIndex)}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col xs={12} sm={2}>
                                    <Label>% doanh số</Label>
                                    <FormGroup>
                                        <Input
                                            disabled={isView}
                                            type="number"
                                            value={calculationLine.percentage_of_revenue}
                                            onChange={(e) => updateAttr(e.target.value, 'percentage_of_revenue', calculationLine.lineIndex)}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col xs={12} sm={3}>
                                    <Label>Số fix</Label>
                                    <FormGroup>
                                        <NumberFormat
                                            className="form-control"
                                            disabled={isView}
                                            thousandSeparator={true}
                                            value={calculationLine.fixed_rental_amount}
                                            onChange={(e) => updateAttr(e.target.value, 'fixed_rental_amount', calculationLine.lineIndex)}
                                        />
                                    </FormGroup>
                                </Col>
                                {(calculationLine.lineIndex > 0 && !isView) &&
                                    <Col xs={12} sm={1}>
                                        <Label>Xóa</Label>
                                        <FormGroup>
                                            <Button
                                                size="sm"
                                                color="danger"
                                                onClick={() => removeLine(calculationLine.lineIndex)}
                                            >
                                                <i className="material-icons">remove</i>
                                            </Button>
                                        </FormGroup>
                                    </Col>
                                }
                            </Row>
                        ))}
                    </div>
                }
                {!isView &&
                    <Row>
                        <Col xs={12}>
                            <Form inline>
                                <FormGroup>
                                    <Button
                                        color="primary"
                                        onClick={addNewCalculationLine}
                                    >
                                        <i className="material-icons">
                                            add
                                        </i>
                                        Thêm dòng mới
                                    </Button>
                                </FormGroup>
                            </Form>
                        </Col>
                    </Row>
                }
            </ModalBody>
        {!isView ?
            <ModalFooter>
                <Button color="secondary" onClick={cancelModal}>Hủy</Button>
                <Button color="primary" onClick={saveCalculationResult}>Lưu</Button>{' '}
            </ModalFooter>
            :
            <ModalFooter>
                <Button color="secondary" onClick={cancelModal}>Quay lại</Button>
            </ModalFooter>
        }
        </Modal>
    );
}

const styles = {
    yearListing: {
        marginTop: 12,
    },
    sectionTitle: {
        marginTop: 12,
        marginLeft: 12,
        marginBottom: 12,
        paddingLeft: 12,
        paddingTop: 6,
        paddingBottom: 6,
        color: 'var(--color-accent-dark)',
        borderLeft: '2px solid var(--color-accent-dark)',
        fontSize: 18,
        fontWeight: 500,
    },
    totalPriceLabel: {
        color: 'var(--color-muted)',
        fontSize: 18,
        display: 'flex',
        justifyContent: 'flex-end',
    },
    totalPrice: {
        fontWeight: 500,
        marginLeft: 6,
    },
    summarySection: {
        marginTop: 12,
    },
    totalPriceAfterCalculationLabel: {
        fontSize: 18,
        marginTop: 12,
        display: 'flex',
        justifyContent: 'flex-end',
    },
    totalPriceAfterCalculation: {
        marginLeft: 6,
        fontWeight: 500,
    }
};
